import React from 'react';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { notificationApi } from '@bingads-webui-campaign/notification-center';
import { storeSeasonalityAdjustmentName, getSeasonalityAdjustmentName } from '@bingads-webui-campaign/seasonality-id-name-utils';
import { SeasonalityAdjustmentCreationPanel } from './creation-form/seasonality-adjustment-creation-form';
import { localizeApiError } from './i18n-map/localize-api-errors';

export function toolbarActionFactory({
  i18n,
  jsdata,
  scope,
  getGridView,
  reloadGrid,
  showTopOfGridPanel,
  adjustmentType,
}) {
  function onDeleteSeasonality(seasonalityId) {
    jsdata.SeasonalityAdjustment.destroy(seasonalityId)
      .then(() => {
        reloadGrid({ resetSelection: true });
        const storedName = getSeasonalityAdjustmentName(seasonalityId);
        if (storedName) {
          storeSeasonalityAdjustmentName({ id: seasonalityId, name: i18n.getString(_TL_('(deleted)')) });
        }
      })
      .catch((error) => {
        reloadGrid({ resetSelection: true });
        notificationApi.showWarning(localizeApiError(error, i18n, adjustmentType));
      })
      .finally(withUiBlock(getGridView().$el));
  }

  function onEditSeasonality(seasonalityId) {
    const creationView = (
      <SeasonalityAdjustmentCreationPanel
        adjustmentType={adjustmentType}
        onSuccess={() => {
          showTopOfGridPanel(null);
          reloadGrid();
        }}
        onCancel={() => {
          showTopOfGridPanel(null);
        }}
        seasonalityId={seasonalityId}
        isUpdate
        scope={scope}
      />
    );
    showTopOfGridPanel(creationView);
  }

  return {
    onDeleteSeasonality,
    onEditSeasonality,
  };
}
